import type { ValueElementIdReferenceAPI } from '../../../../../../../../types/value';
import FormGroup from '../../../../../../../generic/FormGroup';
import InputOrValuePicker from '../../../../../../../generic/InputOrValuePicker';

interface InputWithValuePickerProps {
    id: string;
    label: string;
    isRequired?: boolean;
    testId: string;
    value: string | ValueElementIdReferenceAPI | undefined;
    onChangeAsValueReference: (value: string | ValueElementIdReferenceAPI | null) => void;
    placeholder: string;
    title: string;
    container: HTMLElement | null;
    description?: string;
}

const InputWithValuePicker = ({
    id,
    label,
    isRequired = false,
    testId,
    value,
    onChangeAsValueReference,
    placeholder,
    title,
    container,
    description,
}: InputWithValuePickerProps) => {
    return (
        <FormGroup label={label} htmlFor={id} isRequired={isRequired} testId={testId}>
            <InputOrValuePicker
                value={value ?? null}
                onChangeAsValueReference={onChangeAsValueReference}
                contentType={'ContentString'}
                includeSystemValues={false}
                container={container}
            >
                <input
                    placeholder={placeholder}
                    className="form-control"
                    id={id}
                    type="text"
                    value={(value as string) ?? ''}
                    onChange={(event) => {
                        onChangeAsValueReference(event.target.value);
                    }}
                    title={title}
                    required={isRequired}
                />
            </InputOrValuePicker>
            {description && <p className="quiet ex-mt-2x-small">{description}</p>}
        </FormGroup>
    );
};

export default InputWithValuePicker;
